"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLists = void 0;
const casing_1 = require("@owner/casing");
const casing_2 = require("./casing");
const getLists = (lists, configs) => lists.map(({ collection, name, isPreselectionList, preselectedList, sourceList, primaryRelationship, }) => {
    return {
        collection,
        primaryRelationship: primaryRelationship ?? false,
        preselectedList: preselectedList ?? null,
        sourceList: sourceList ?? null,
        isPreselectionList: isPreselectionList ?? false,
        collectionCasing: (0, casing_2.getCasing)(configs[collection]),
        listCasing: {
            camel: name,
            kebab: (0, casing_1.camelToKebab)(name),
            pascal: (0, casing_1.camelToPascal)(name),
        },
        name,
    };
});
exports.getLists = getLists;
//# sourceMappingURL=lists.js.map